import * as React from "react";
import { forwardRef } from "react";
const SvgTrashBlack = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 19, viewBox: "0 0 20 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4 6V17H16V6H13V0H15V4H20V6H18V18C18 18.2652 17.8946 18.5196 17.7071 18.7071C17.5196 18.8946 17.2652 19 17 19H3C2.73478 19 2.48043 18.8946 2.29289 18.7071C2.10536 18.5196 2 18.2652 2 18V6H0V4H5V0H7V6H4ZM11 0V6H9V0H11Z", fill: "#0D0D0D" }));
const ForwardRef = forwardRef(SvgTrashBlack);
export default ForwardRef;
